import React, { useState, useRef, useEffect, useCallback } from 'react';
import { C } from './AnalyticsTokens';
import { KPI_DEFS, STATUS_ITEMS, ALL_STATUS_VALUES, MONATE_DE, DOW_DE } from './AnalyticsConstants';
import { pct } from './AnalyticsUtils';
import { CalendarSVG } from './AnalyticsIcons';

import { EXTERN_INIT, EXTERN_STATUS_OPTIONEN } from './AnalyticsConstants';

export function ExternModal({ onSchliessen, onErstellen }) {
  const [form, setForm] = useState(EXTERN_INIT);
  const [speichert, setSpeichert] = useState(false);

  function set(feld, wert) {
    setForm(f => ({ ...f, [feld]: wert }));
  }

  async function onSubmit(e) {
    e.preventDefault();
    if (!form.name.trim()) return;
    setSpeichert(true);
    try {
      await onErstellen(form);
      onSchliessen();
    } finally {
      setSpeichert(false);
    }
  }

  return (
    <div className="an-em-overlay" onClick={onSchliessen}>
      <div className="an-em-card" onClick={e => e.stopPropagation()}>

        <div className="an-em-header">
          <div className="an-em-header-text">
            <span className="an-em-eyebrow">Manuell tracken</span>
            <h2 className="an-em-title">Externe Bewerbung</h2>
          </div>
          <button className="an-em-close" onClick={onSchliessen} aria-label="Schließen">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        <form className="an-em-body" onSubmit={onSubmit}>
          <div className="an-em-grid">
            <div className="an-em-field an-em-field--span2">
              <label className="an-em-label">Unternehmen *</label>
              <input
                className="an-em-input"
                value={form.name}
                onChange={e => set('name', e.target.value)}
                placeholder="z. B. Acme GmbH"
                required
                autoFocus
              />
            </div>
            <div className="an-em-field an-em-field--span2">
              <label className="an-em-label">Plattform</label>
              <input
                className="an-em-input"
                value={form.plattform}
                onChange={e => set('plattform', e.target.value)}
                placeholder="z. B. Indeed, LinkedIn, XING …"
              />
            </div>
            <div className="an-em-field">
              <label className="an-em-label">Ansprechpartner</label>
              <input
                className="an-em-input"
                value={form.empfaenger_ansprechperson}
                onChange={e => set('empfaenger_ansprechperson', e.target.value)}
                placeholder="z. B. Max Mustermann"
              />
            </div>
            <div className="an-em-field">
              <label className="an-em-label">Gehaltsvorstellung</label>
              <input
                className="an-em-input"
                value={form.gehaltsvorstellung}
                onChange={e => set('gehaltsvorstellung', e.target.value)}
                placeholder="z. B. 55.000 €"
              />
            </div>
            <div className="an-em-field">
              <label className="an-em-label">Status</label>
              <select
                className="an-em-input an-em-select"
                value={form.bewerbungs_status}
                onChange={e => set('bewerbungs_status', e.target.value)}
              >
                {EXTERN_STATUS_OPTIONEN.map(o => (
                  <option key={o.value} value={o.value}>{o.label}</option>
                ))}
              </select>
            </div>
            <div className="an-em-field">
              <label className="an-em-label">Abgeschickt am</label>
              <input
                className="an-em-input"
                type="date"
                value={form.abschick_datum}
                onChange={e => set('abschick_datum', e.target.value)}
              />
            </div>
            <div className="an-em-field">
              <label className="an-em-label">Interview am</label>
              <input
                className="an-em-input"
                type="date"
                value={form.interview_datum}
                onChange={e => set('interview_datum', e.target.value)}
              />
            </div>
            <div className="an-em-field">
              <label className="an-em-label">Uhrzeit</label>
              <input
                className="an-em-input"
                type="time"
                value={form.interview_uhrzeit}
                onChange={e => set('interview_uhrzeit', e.target.value)}
              />
            </div>
          </div>

          <div className="an-em-footer">
            <button type="button" className="an-em-btn an-em-btn--cancel" onClick={onSchliessen}>
              Abbrechen
            </button>
            <button type="submit" className="an-em-btn an-em-btn--primary" disabled={speichert || !form.name.trim()}>
              {speichert ? 'Speichert…' : 'Bewerbung hinzufügen'}
            </button>
          </div>
        </form>

      </div>
    </div>
  );
}

export function HeroCard({ gesamt }) {
  return (
    <div className="analytics-kpi-gesamt">
      <div className="analytics-kpi-gesamt-left">
        <div className="analytics-kpi-gesamt-eyebrow">Gesamtübersicht</div>
        <div className="analytics-kpi-gesamt-num">{gesamt}</div>
        <div className="analytics-kpi-gesamt-label">Bewerbungen</div>
      </div>
      <div className="analytics-kpi-gesamt-icon">📊</div>
    </div>
  );
}

export function KPIGrid({ submitted, interview, zusage, absage, gesamt }) {
  const vals = { submitted, interview, zusage, absage };
  return (
    <div className="analytics-kpi-row">
      {KPI_DEFS.map(k => (
        <div key={k.key} className={`analytics-kpi-mini analytics-kpi-mini--${k.key === 'submitted' ? 'amber' : k.key === 'interview' ? 'teal' : k.key === 'zusage' ? 'success' : 'danger'}`}>
          <div className="analytics-kpi-mini-label">{k.label}</div>
          <div className="analytics-kpi-mini-num">{vals[k.key]}</div>
          <div className="analytics-kpi-mini-pct">{pct(vals[k.key], gesamt)}</div>
        </div>
      ))}
    </div>
  );
}

export function FilterCheckbox({ checked, color }) {
  return (
    <div style={{
      width: 17, height: 17, borderRadius: 4, flexShrink: 0,
      border: checked ? `2px solid ${color}` : '1.5px solid rgba(0,0,0,0.22)',
      background: checked ? color : 'transparent',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      transition: 'all 0.12s',
    }}>
      {checked && (
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
          <path d="M2 5l2.5 2.5L8 3" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )}
    </div>
  );
}

export function StatusFilterDropdown({ selected, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return;
    function h(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }
    document.addEventListener('mousedown', h);
    document.addEventListener('touchstart', h);
    return () => { document.removeEventListener('mousedown', h); document.removeEventListener('touchstart', h); };
  }, [open]);

  const allSel  = selected.size === ALL_STATUS_VALUES.length;
  const noneSel = selected.size === 0;
  let btnLabel = 'Alle';
  if (!allSel && !noneSel) {
    if (selected.size === 1) {
      const v = [...selected][0];
      btnLabel = STATUS_ITEMS.find(s => s.value === v)?.label ?? 'Alle';
    } else {
      btnLabel = `${selected.size} Status`;
    }
  }

  const toggleAll = useCallback((e) => {
    e.stopPropagation();
    onChange(allSel ? new Set() : new Set(ALL_STATUS_VALUES));
  }, [allSel, onChange]);

  const toggleOne = useCallback((e, value) => {
    e.stopPropagation();
    const next = new Set(selected);
    if (next.has(value)) next.delete(value); else next.add(value);
    onChange(next);
  }, [selected, onChange]);

  const selectOnly = useCallback((e, value) => {
    e.stopPropagation();
    onChange(new Set([value]));
  }, [onChange]);

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button onClick={() => setOpen(v => !v)} style={{
        display: 'flex', alignItems: 'center', gap: 4,
        background: C.surface, border: `1px solid ${C.borderMid}`,
        borderRadius: 999, padding: '6px 10px 6px 13px',
        fontSize: 12, fontWeight: 600, color: C.text,
        cursor: 'pointer', boxShadow: C.shadow,
        WebkitTapHighlightColor: 'transparent', fontFamily: C.body,
      }}>
        {btnLabel}
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" style={{ marginTop: 1, opacity: 0.55 }}>
          <path d="M3 4.5l3 3 3-3" stroke={C.text} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
      {open && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 7px)', left: 0,
          background: C.surface, border: `1px solid ${C.border}`,
          borderRadius: 16, boxShadow: '0 10px 36px rgba(0,0,0,0.13), 0 2px 8px rgba(0,0,0,0.07)',
          zIndex: 300, minWidth: 190, overflow: 'hidden',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', padding: '11px 14px 10px', borderBottom: `1px solid ${C.border}`, gap: 10 }}>
            <div onClick={toggleAll} style={{ cursor: 'pointer', display: 'flex' }}>
              <FilterCheckbox checked={allSel} color={C.teal} />
            </div>
            <span onClick={toggleAll} style={{ fontSize: 14, fontWeight: 600, color: C.text, cursor: 'pointer', flex: 1, fontFamily: C.body, WebkitTapHighlightColor: 'transparent' }}>Alle</span>
          </div>
          {STATUS_ITEMS.map(item => {
            const checked = allSel || noneSel || selected.has(item.value);
            return (
              <div key={item.value} style={{ display: 'flex', alignItems: 'center', padding: '10px 14px', borderBottom: `1px solid ${C.border}`, gap: 10 }}>
                <div onClick={e => toggleOne(e, item.value)} style={{ cursor: 'pointer', display: 'flex' }}>
                  <FilterCheckbox checked={checked} color={item.dot} />
                </div>
                <div style={{ width: 8, height: 8, borderRadius: '50%', background: item.dot, flexShrink: 0 }} />
                <span onClick={e => selectOnly(e, item.value)} style={{ fontSize: 13, fontWeight: 400, color: C.text, cursor: 'pointer', flex: 1, fontFamily: C.body, WebkitTapHighlightColor: 'transparent' }}>{item.label}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export function SourceSegment({ value, onChange }) {
  const opts = [{ v: 'alle', l: 'Alle' }, { v: 'cvflow', l: 'CVFlow' }, { v: 'extern', l: 'Extern' }];
  return (
    <div style={{ display: 'inline-flex', background: C.surface, border: `1px solid ${C.borderMid}`, borderRadius: 999, padding: 3, boxShadow: C.shadow, gap: 2 }}>
      {opts.map(({ v, l }) => {
        const active = value === v;
        return (
          <button key={v} onClick={() => onChange(v)} style={{
            padding: '5px 13px', borderRadius: 999, border: 'none',
            background: active ? C.teal : 'transparent', color: active ? '#fff' : C.textMuted,
            fontSize: 12, fontWeight: 600, color: active ? '#fff' : C.textMuted, cursor: 'pointer',
            transition: 'all 0.14s', WebkitTapHighlightColor: 'transparent', fontFamily: C.body,
          }}>{l}</button>
        );
      })}
    </div>
  );
}

export function MiniCalendar({ value, onChange, placeholder = 'Datum wählen', style: outerStyle }) {
  const today    = new Date();
  const todayISO = `${today.getFullYear()}-${String(today.getMonth()+1).padStart(2,'0')}-${String(today.getDate()).padStart(2,'0')}`;

  const containerRef = useRef(null);
  const [localValue, setLocalValue] = useState(value || '');
  const [open,       setOpen]       = useState(false);
  const [openUp,     setOpenUp]     = useState(false);
  const [viewYear,   setViewYear]   = useState(() => {
    const src = value || todayISO;
    return parseInt(src.slice(0, 4), 10);
  });
  const [viewMonth,  setViewMonth]  = useState(() => {
    const src = value || todayISO;
    return parseInt(src.slice(5, 7), 10) - 1;
  });

  useEffect(() => {
    setLocalValue(value || '');
    if (value) {
      setViewYear(parseInt(value.slice(0, 4), 10));
      setViewMonth(parseInt(value.slice(5, 7), 10) - 1);
    }
  }, [value]);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  function prevMonth() {
    if (viewMonth === 0) { setViewMonth(11); setViewYear(y => y - 1); }
    else setViewMonth(m => m - 1);
  }
  function nextMonth() {
    if (viewMonth === 11) { setViewMonth(0); setViewYear(y => y + 1); }
    else setViewMonth(m => m + 1);
  }
  function selectDay(day) {
    const iso = `${viewYear}-${String(viewMonth+1).padStart(2,'0')}-${String(day).padStart(2,'0')}`;
    setLocalValue(iso);
    onChange(iso);
    setOpen(false);
  }
  function selectToday() {
    setLocalValue(todayISO);
    onChange(todayISO);
    setOpen(false);
  }
  function clearDate() {
    setLocalValue('');
    onChange('');
    setOpen(false);
  }

  const firstDow    = new Date(viewYear, viewMonth, 1).getDay();
  const startOffset = firstDow === 0 ? 6 : firstDow - 1;
  const daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();
  const cells = [];
  for (let i = 0; i < startOffset; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);
  while (cells.length % 7 !== 0) cells.push(null);

  const parsedLocal = localValue ? new Date(localValue + 'T12:00:00') : null;
  const displayValue = parsedLocal
    ? parsedLocal.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' })
    : null;

  const navBtn = {
    background: 'rgba(255,255,255,0.13)', border: '1px solid rgba(255,255,255,0.18)',
    cursor: 'pointer', width: 36, height: 36, borderRadius: 10,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    WebkitTapHighlightColor: 'transparent', flexShrink: 0,
  };

  return (
    <div ref={containerRef} style={{ position: 'relative', ...outerStyle }}>
      <button
        type="button"
        onClick={() => {
          if (!open && containerRef.current) {
            const rect = containerRef.current.getBoundingClientRect();
            setOpenUp(window.innerHeight - rect.bottom < 340);
          }
          setOpen(v => !v);
        }}
        style={{
          width: '100%', padding: '9px 12px',
          display: 'flex', alignItems: 'center', gap: 8,
          border: `1.5px solid ${open ? C.amber : C.borderMid}`,
          borderRadius: 10, background: C.bg, outline: 'none',
          cursor: 'pointer', fontFamily: C.body,
          boxShadow: open ? '0 0 0 3px rgba(255,188,0,0.15)' : 'none',
          boxSizing: 'border-box', WebkitTapHighlightColor: 'transparent',
          transition: 'border-color 0.15s, box-shadow 0.15s',
        }}
      >
        <CalendarSVG size={14} />
        <span style={{
          flex: 1, textAlign: 'left', fontSize: 14,
          color: displayValue ? C.text : C.textDim,
          fontWeight: displayValue ? 500 : 400, fontFamily: C.body,
        }}>
          {displayValue || placeholder}
        </span>
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
          style={{ opacity: 0.4, flexShrink: 0, transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.15s' }}>
          <path d="M3 4.5l3 3 3-3" stroke={C.text} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>

      {open && (
        <div style={{
          position: 'absolute', left: 0, right: 0, zIndex: 200,
          ...(openUp
            ? { bottom: 'calc(100% + 8px)' }
            : { top: 'calc(100% + 8px)' }
          ),
          background: C.surface,
          border: `1px solid ${C.borderMid}`, borderRadius: 14,
          overflow: 'hidden',
          boxShadow: '0 8px 28px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.06)',
        }}>
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '10px 12px', background: C.teal,
          }}>
            <button type="button" onClick={prevMonth} style={navBtn}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M10 12l-4-4 4-4" stroke="rgba(255,255,255,0.9)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <span style={{ fontSize: 14, fontWeight: 700, color: '#fff', letterSpacing: '0.02em' }}>
              {MONATE_DE[viewMonth]} {viewYear}
            </span>
            <button type="button" onClick={nextMonth} style={navBtn}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6 4l4 4-4 4" stroke="rgba(255,255,255,0.9)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>

          <div style={{
            display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)',
            padding: '8px 6px 4px', background: 'rgba(0,77,64,0.05)',
          }}>
            {DOW_DE.map(d => (
              <div key={d} style={{
                textAlign: 'center', fontSize: 10, fontWeight: 700,
                color: C.textDim, letterSpacing: '0.08em',
              }}>{d}</div>
            ))}
          </div>

          <div style={{
            display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)',
            padding: '4px 6px 8px', rowGap: 2,
          }}>
            {cells.map((day, i) => {
              if (!day) return <div key={i} style={{ aspectRatio: '1' }} />;
              const iso     = `${viewYear}-${String(viewMonth+1).padStart(2,'0')}-${String(day).padStart(2,'0')}`;
              const isSel   = iso === localValue;
              const isToday = iso === todayISO;
              return (
                <button
                  key={i} type="button"
                  onClick={() => selectDay(day)}
                  style={{
                    aspectRatio: '1', width: '100%',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 13, fontWeight: isSel ? 700 : isToday ? 600 : 400,
                    background: isSel ? C.amber : isToday ? 'rgba(0,77,64,0.08)' : 'transparent',
                    color: isSel ? '#3A2700' : isToday ? C.teal : C.text,
                    borderRadius: 8,
                    border: isToday && !isSel ? `1.5px solid ${C.teal}` : '1.5px solid transparent',
                    cursor: 'pointer', fontFamily: C.body,
                    WebkitTapHighlightColor: 'transparent', boxSizing: 'border-box',
                  }}
                >
                  {day}
                </button>
              );
            })}
          </div>

          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '8px 12px 12px', borderTop: `1px solid ${C.border}`,
          }}>
            <button type="button" onClick={clearDate} style={{
              background: 'none', border: 'none', cursor: 'pointer',
              fontSize: 12, color: C.textMuted, fontFamily: C.body, padding: '4px 0',
              WebkitTapHighlightColor: 'transparent',
            }}>Leeren</button>
            <button type="button" onClick={selectToday} style={{
              background: C.tealMid, border: `1px solid rgba(0,77,64,0.2)`,
              borderRadius: 999, cursor: 'pointer',
              fontSize: 12, fontWeight: 600, color: C.teal, fontFamily: C.body,
              padding: '5px 14px', WebkitTapHighlightColor: 'transparent',
            }}>Heute</button>
          </div>
        </div>
      )}
    </div>
  );
}
